import React from 'react';
import classNames from 'classnames';

import styles from '../MobileCard.module.scss';

import { MobileCardData, MobileField } from '../../types';

export function Title<D extends MobileCardData>(field: MobileField<D>, dataItem: D): React.ReactElement<any> {
    return (
        <label
            className={classNames([styles.label, field.isPrimary && styles.textValuePrimary])}
            htmlFor={dataItem.id}
        >
            {field.title}
        </label>
    );
}
